import {bodyColors} from './data/config'
import React from 'react'

const Colors = ({isMobile, selectedColor, setSelectedColor}) => {

    const handleClick = (color) => () => {
        setSelectedColor(color);
    }

    return <div>
    <h2 className='section-title'>Paint Colour</h2>
    <h3 className='selection-title'>{selectedColor.name}</h3>
    <div className='grid grid-cols-10 flex-wrap'>
        {bodyColors.map(color => {
            const imagePath = `./images/${isMobile ? 'Mobile/' : ''}Colour_Swatches/TATC_Config_Colour_Swatches_${color.prefix}${isMobile ? '_Mobile' : ''}.png`;
            return <div key={color.name} className={`hover:bg-slate-200 rounded-md flex items-center justify-center p-1 text-white cursor-pointer duration-300 ${color.name === selectedColor.name && "bg-tan-300 hover:bg-tan-300"}`} onClick={handleClick(color)}>
                <img src={imagePath} alt={color.name} />
            </div>
        })}
    </div> 
  </div>
}

export default Colors